import { Core } from './Core';

import { DOMHelper } from 'core/DOMHelper';

export abstract class Module {
	public id: string;
	public tag: string;
	public $container: HTMLElement;
	public moduleName: string;
	public mounted: boolean = false;
	public destroyed: boolean = false;
	public removed: boolean = false;
	public active: boolean = true;
	public config: any = {};

	protected DOM: DOMHelper;

	constructor() {
		this.DOM = Core.DOM;
	}

	public init() {
		this.DOM = Core.DOM;
	}

	public create(): void {}
	public tick(delta: number = null): void {}
	public DOMReady(): void {}

	public destroy(): void {
		this.DOM = null;
	}

	public scroll(windowY: number) {}

	public resize(sizes: any) {}

	//Convert an elements attributes to
	protected attributesToConfig(prefix: string, item: any = null, element: Element = null): void {
		if (!element && this.$container) {
			element = this.$container;
		}

		if (!item) {
			item = this;
		}

		if (!element) {
			return;
		}
	}


}
